<template>
	<div class="ryuic9 bb2" :class="{ 'not-fixed': !isFixed }">
		<div class="bar">
			<!-- Left -->
			<div class="flex xs-6 md-3 xs-left xs-middle">
				<img
					:src="logo || require('@public/img/logo.png')"
					:height="logoHeight"
				/>
			</div>

			<!-- Middle -->
			<div class="md-flex xs-0 md-6 xs-center xs-middle"></div>

			<!-- Right -->
			<div class="flex xs-6 md-3 xs-right xs-middle">
				<!-- Wrapper -->
				<div
					v-if="contact"
					class="flex xs-hide md-show xs-column xs-6 md-12 xs-right ta3 fs3 fw7 c1 mr2"
				>
					<a :href="`tel:${contact.tel}`">
						<span class="c1">{{ contact.tel }}</span>
					</a>
					<a :href="`mailto:${contact.email}`">
						<span class="c1">{{ contact.email }}</span>
					</a>
				</div>

				<select v-on:change="switchLocale">
					<option
						v-for="(locale, i) in locales"
						:key="`locale${i}`"
						:value="locale.value"
						>{{ locale.name }}</option
					>
				</select>

				<div class="xs-6 md-6 lg-4 xs-right xs-middle xs-0 md-flex"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "comparison-top-bar",
	props: {
		isFixed: {
			type: Boolean,
			required: false,
			default: true
		},
		logo: {
			type: String,
			required: false
		},
		logoHeight: {
			type: String,
			default: "30"
		},
		tenant: {
			required: false
		},
		locales: {
			type: Array,
			required: false,
			default: () => [
				{ value: "en", name: "English" },
				{ value: "zh-HK", name: "中文" }
			]
		},
		isCTA: {
			type: Boolean,
			required: false,
			default: false
		},
		ctaText: {
			type: String,
			required: false,
			default: "CTA"
		},
		ctaLink: {
			type: String,
			required: false,
			default: "#"
		},
		languageNames: {
			type: Object,
			required: false,
			default: () => ({ en: "EN", "zh-HK": "中文" })
		},
		topMenu: {
			type: Array,
			required: false
		},
		contact: {
			type: Object,
			required: false
		}
	},
	data() {
		return {
			mobileMenu: null,
			menuOpen: false
		}
	},
	methods: {
		switchLocale(event) {
			const locale = event.target.value
			this.$i18n.locale = locale
		}
	}
}
</script>

<style scoped>
@import "../../assets/css/tokens.css";

.ryuic9 {
	/* position: fixed;
  top: 0;
  left: 0; */
	width: 100%;
	height: 56px;
	padding: 0 var(--spacing2);
	background-color: var(--header-background-color);
	border-color: var(--header-background-color);
	color: var(--header-font-color);
	z-index: 100;
}

.ryuic9 a {
	color: var(--header-font-color);
}

.bar {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	width: 100%;
	max-width: var(--maxWidth7);
	height: 100%;
	margin: 0 auto;
}

.not-fixed {
	position: static !important;
}

.xs-hide {
	display: none;
}

.hamburger {
	z-index: 11;
	color: #5b4e6e;
	cursor: pointer;
	position: fixed;
}

.mobile-menu {
	display: none;
	position: fixed;
	width: 85%;
	max-width: 400px;
	height: 110vh;
	/* background: linear-gradient(135deg, #5c93c4 2%, #5c93c4 45%, #5b4e6e 100%); */
	background: var(--menu-background-color, var(--header-background-color));
	padding: 1em;
	box-sizing: border-box;
	height: 100%;
	right: -300px;
	top: 0;
	z-index: 10;
	text-align: left;
	font-family: "arial";
	color: rgb(60, 60, 60);
	font-weight: bold;
	font-size: 20px;
	box-shadow: -9px 0 12px -1px rgba(0, 0, 0, 0.1);
}

.mobile-menu a {
	color: var(--menu-font-color, var(--color1));
}

.active {
	display: block;
}

@media (--md) {
	.ryuic9 {
		/* position: sticky;
    top: 0;
    left: 0; */
	}

	.hamburger {
		display: none;
	}

	.active {
		display: none;
	}

	.mobile-menu {
		display: none;
	}

	.md-show {
		display: flex;
	}

	.not-fixed {
		position: static !important;
	}
}
</style>
